import scrollObserver from "./observer"
import VanillaTilt from "vanilla-tilt"

const body = document.querySelector("body")
const header = document.querySelector("#header")
const content = document.querySelector("#content")
const offCanvasMenu = document.querySelector(".off-canvas-menu")

let lastScrollTop = 0

window.addEventListener('DOMContentLoaded', function () {
    // Navigation toggle
    let main_navigation = document.querySelector('#primary-menu')
    document.querySelector('#primary-menu-toggle').addEventListener('click', function (e) {
        e.preventDefault()
        body.classList.toggle('overflow-hidden')
        main_navigation.classList.toggle('active')
    })

    // Load in animation
    scrollObserver(".ambee-load-in")

    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    })

    tippy('[data-tippy-content]', {
        content(reference) {
            const id = reference.getAttribute('data-template')
            const template = document.getElementById(id)
            return template.innerHTML
        },
        allowHTML: true,
        maxWidth: 'none',
    })

    document.querySelectorAll('.ambee-content').forEach(div => {
        div.querySelectorAll('p').forEach(p => {
            if (p.innerHTML.trim() === '' || p.innerHTML.trim() === '<br>') {
                p.remove()
            }
        })
    })

    document.querySelectorAll('.ambee-content-title').forEach(h4 => {
        if (h4.innerHTML.trim().endsWith('<br>')) {
            h4.innerHTML = h4.innerHTML.trim().slice(0, -4) // Remove the last <br> tag
        }
    })

    VanillaTilt.init(document.querySelectorAll(".product-card .attachment-woocommerce_thumbnail"))

    const scrollBanner = document.querySelector('.ambee-scroll-banner')
    if (scrollBanner) {
        const bannerWidth = scrollBanner.offsetWidth  // Get the width of the container
        const scrollSpeed = 1  // Speed of scroll (higher value makes it slower)

        // Clone the content inside the scroll banner
        const clonedContent = scrollBanner.cloneNode(true)
        scrollBanner.appendChild(clonedContent)  // Append the cloned content to create infinite loop effect

        function scroll() {
            // Move the content to the left
            scrollBanner.scrollLeft += scrollSpeed

            // If the first part of the banner has scrolled to the end, reset the scroll position
            if (scrollBanner.scrollLeft >= bannerWidth) {
                scrollBanner.scrollLeft = 0
            }
        }

        // Start scrolling every 10 milliseconds (adjust for smoothness)
        setInterval(scroll, 20)
    }
})

window.addEventListener("scroll", function () {
    let currentScroll = window.pageYOffset || document.documentElement.scrollTop

    if (currentScroll > lastScrollTop) {
        header.classList.add("scrolled")
    } else {
        header.classList.remove("scrolled")
    }

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll
})

// Function to get the height of the header element
function getHeaderHeight() {
    return header.offsetHeight
}

// Apply padding to the content element equal to the height of the header
function applyPaddingToOffCanvasMenu() {
    const headerHeight = getHeaderHeight()
    const viewportHeight = document.documentElement.clientHeight
    const remainingHeight = viewportHeight - headerHeight

    offCanvasMenu.style.height = `${remainingHeight}px`
}

// Update padding on window resize (optional)
window.addEventListener("resize", applyPaddingToOffCanvasMenu)

// Initial padding setup
applyPaddingToOffCanvasMenu()